/**
 * mg-label-preview.js
 * Live text overlay on Golf ID Labels product carousel images.
 * Binds to .personalization-input fields and projects typed text
 * onto pgLab_BK / pgLab_CH images in real-time.
 */
(function () {
  'use strict';

  var LINE_COUNT = 4;

  /* ---- helpers ---- */

  function getVariantClass(src) {
    if (src.indexOf('pgLab_BK') !== -1) return 'mg-label-bk';
    if (src.indexOf('pgLab_CH') !== -1) return 'mg-label-ch';
    return null;
  }

  function createOverlay(variantClass) {
    var div = document.createElement('div');
    div.className = 'mg-label-overlay ' + variantClass;
    for (var i = 0; i < LINE_COUNT; i++) {
      div.appendChild(document.createElement('span'));
    }
    return div;
  }

  /* ---- overlay injection ---- */

  var overlays = []; // track all created overlays for live-update

  function isThumbnail(img) {
    // Skip small thumbnail images (sidebar nav thumbnails are typically < 100px)
    if (img.closest('.thumbnail-list, .thumbnail, [id*="thumbnail"], .product__media-toggle')) return true;
    var rect = img.getBoundingClientRect();
    if (rect.width > 0 && rect.width < 150) return true;
    return false;
  }

  function attachOverlay(img) {
    var src = img.getAttribute('src') || '';
    var variantClass = getVariantClass(src);
    if (!variantClass) return;

    // Skip thumbnail / nav images
    if (isThumbnail(img)) return;

    // Avoid duplicating if already attached
    var parent = img.closest('.media') || img.parentElement;
    if (!parent) return;
    if (parent.querySelector('.mg-label-overlay')) return;

    // Ensure parent is positioned for absolute overlay
    var pos = window.getComputedStyle(parent).position;
    if (pos === 'static' || pos === '') parent.style.position = 'relative';

    var overlay = createOverlay(variantClass);
    parent.appendChild(overlay);
    overlays.push(overlay);

    // Immediately populate with current input values
    syncOverlayText();
  }

  function scanImages(root) {
    var imgs = (root || document).querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      attachOverlay(imgs[i]);
    }
  }

  /* ---- live text sync ---- */

  function syncOverlayText() {
    var inputs = document.querySelectorAll('.personalization-input');
    overlays.forEach(function (overlay) {
      var spans = overlay.querySelectorAll('span');
      for (var i = 0; i < LINE_COUNT; i++) {
        var val = inputs[i] ? inputs[i].value : '';
        spans[i].textContent = val;
      }
    });
  }

  /* ---- form validation (moved from inline script) ---- */

  function initFormValidation() {
    var form = document.querySelector('[data-type="add-to-cart-form"]');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      var inputs = form.querySelectorAll('.personalization-input');
      var hasValue = Array.from(inputs).some(function (input) {
        return input.value.trim() !== '';
      });

      if (!hasValue) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        alert('Please enter at least one line of personalization before adding to cart.');
        return false;
      }
    }, true); // capture phase
  }

  /* ---- init ---- */

  function init() {
    // Scan existing images
    scanImages();

    // Bind input events
    var inputs = document.querySelectorAll('.personalization-input');
    inputs.forEach(function (input) {
      input.addEventListener('input', syncOverlayText);
    });

    // MutationObserver for lazy-loaded / carousel-injected images
    var gallery = document.querySelector('.product__media-list, .product-media-container, .product__media-wrapper');
    if (gallery) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.tagName === 'IMG') attachOverlay(node);
            else scanImages(node);
          });
        });
      });
      observer.observe(gallery, { childList: true, subtree: true });
    }

    // Also watch for src changes on existing images (lazy-load swaps)
    var allImgs = document.querySelectorAll('.product__media-list img, .product-media-container img');
    if (allImgs.length) {
      var srcObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.type === 'attributes' && m.attributeName === 'src') {
            attachOverlay(m.target);
          }
        });
      });
      allImgs.forEach(function (img) {
        srcObserver.observe(img, { attributes: true, attributeFilter: ['src'] });
      });
    }

    // Form validation
    initFormValidation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
